module.exports = __webpack_public_path__ + "static/media/airplane2.3237bfc4.svg";